import { MapPin, Phone } from "lucide-react";
import { PHONE_TEL } from "./data";
import { scrollTo } from "./scroll";

const MobileBar = () => (
  <div
    data-testid="mobile-bottom-bar"
    className="fixed inset-x-0 bottom-0 z-50 grid grid-cols-2 border-t-2 border-ink md:hidden"
  >
    <button
      data-testid="mobile-bar-walkin"
      onClick={() => scrollTo("#contact")}
      className="flex h-16 items-center justify-center gap-2 bg-rust font-display text-xl uppercase tracking-wide text-paper"
    >
      <MapPin size={20} /> Walk in
    </button>
    <a
      href={PHONE_TEL}
      data-testid="mobile-bar-call"
      className="flex h-16 items-center justify-center gap-2 bg-polered font-display text-xl uppercase tracking-wide text-paper"
    >
      <Phone size={20} /> Call
    </a>
  </div>
);

export default MobileBar;
